import React from 'react';
import PageRenderer from '../../components/common/PageRenderer';

function DefaultContent() {
  return (
    <>
      {/* Hero */}
      <section className="relative overflow-hidden bg-[#0B5D1E]" style={{ backgroundImage: 'linear-gradient(135deg, #0B5D1E 0%, #094A18 100%)' }}>
        <div className="relative" style={{ paddingTop: 80, paddingBottom: 80, zIndex: 1 }}>
          <div className="max-w-5xl mx-auto px-4 text-center">
            <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 700, color: '#fff', marginBottom: 16, fontFamily: "'Playfair Display',serif" }}>
              Mission &amp; Vision
            </h1>
            <p className="text-white/70 text-lg max-w-2xl mx-auto">
              Guiding principles of the Nigerian Institution of Surveyors, FCT Branch
            </p>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12">
            <div className="bg-[#F8FAFB] rounded-2xl p-8 border border-gray-100 shadow-sm">
              <div className="w-14 h-14 rounded-xl bg-[#0B5D1E]/10 flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-[#0B5D1E]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>Our Mission</h2>
              <p className="text-gray-600 leading-relaxed">
                To promote and advance the science and practice of surveying in all its branches within the Federal Capital Territory, ensuring the highest standards of professional conduct, competence, and ethical practice among members. We are dedicated to serving the public interest through accurate surveying and geospatial services.
              </p>
            </div>

            <div className="bg-[#F8FAFB] rounded-2xl p-8 border border-gray-100 shadow-sm">
              <div className="w-14 h-14 rounded-xl bg-[#C8A951]/10 flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-[#C8A951]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>Our Vision</h2>
              <p className="text-gray-600 leading-relaxed">
                To be the foremost professional body for surveyors in the FCT, recognized for excellence, innovation, and leadership in the surveying profession. We envision a community of highly skilled professionals who leverage modern technology and best practices to deliver world-class surveying and geospatial solutions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-16 bg-[#F8FAFB]">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-10" style={{ fontFamily: "'Playfair Display',serif" }}>Our Core Values</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { title: 'Professionalism', desc: 'Upholding the highest standards of professional conduct and competence.' },
              { title: 'Integrity', desc: 'Maintaining honesty, transparency, and ethical practice in all endeavours.' },
              { title: 'Excellence', desc: 'Striving for continuous improvement and outstanding service delivery.' },
              { title: 'Collaboration', desc: 'Fostering teamwork and partnerships for the growth of the profession.' },
            ].map((v) => (
              <div key={v.title} className="bg-white rounded-xl p-6 border border-gray-100 shadow-sm">
                <h3 className="text-lg font-bold text-[#0B5D1E] mb-2">{v.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default function MissionVision() {
  return <PageRenderer pageKey="mission_vision" fallback={<DefaultContent />} />;
}
